import { EntitySelect, EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface Team {
  id: string
  name: string
}

interface TeamsSelectorProps {
  availableTeams: Team[] | undefined
  loading: boolean
  value: Array<{ id: string; name: string }> | undefined
  onChange: (selection: EntitySelectEntity[] | EntitySelectEntity | null) => void
}

export const TeamsSelector = ({
  availableTeams = [],
  loading,
  value = [],
  onChange,
}: TeamsSelectorProps) => {
  return (
    <EntitySelect
      label={i18n.t('workflows.sidepanel.approval.strategies.selectors.teams')}
      hideLabel
      size="md"
      loading={loading}
      entities={availableTeams.map((team) => ({
        id: team.id,
        name: team.name,
        expanded: false,
      }))}
      notFoundSubtitle={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.teams_not_found_subtitle'
      )}
      notFoundTitle={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.teams_not_found_title'
      )}
      onGroupChange={() => {}}
      onItemExpandedChange={() => {}}
      onSelect={onChange}
      searchPlaceholder={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.teams_search_placeholder'
      )}
      selectedEntities={value}
      selectedLabel={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.teams_selected_label'
      )}
      singleSelector
      placeholder={i18n.t('workflows.sidepanel.approval.strategies.selectors.teams_placeholder')}
      selectedItemsCopy={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.teams_selected_copy'
      )}
      groups={[]}
      selectedGroup="all"
      clearLabel={i18n.t('workflows.sidepanel.approval.strategies.selectors.teams_clear_label')}
      selectAllLabel={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.teams_select_all_label'
      )}
    />
  )
}
